
import {axiosInstance} from "@/plugins/axios";
import {ResetPasswordState} from "@/modules/reset_password_email/types";

export async function sendResetPasswordEmail(payload: ResetPasswordState) {
  const response = await axiosInstance.post(`reset_password_email`, payload);
  return response.data;
}
